import { useSearchParams } from "react-router-dom";
import { HourglassBottom } from "@mui/icons-material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignInButton } from "../components/sign-in-button";

/** Действовавшая сессия пропала. После входа возвращаем туда, где пользователь был. */
export const SessionExpiredPage = (): JSX.Element => {
  const [searchParams] = useSearchParams();

  return (
    <InfoPageLayout>
      <InfoPage
        title="Сессия завершена"
        message="Войдите снова, чтобы продолжить работу"
        illustration={<InfoPageIllustration icon={HourglassBottom} />}
        actions={<SignInButton returnUrl={searchParams.get("returnUrl")} />}
      />
    </InfoPageLayout>
  );
};
